"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Sums all the values
 * Settings is passed with 'valuePath' to find the items
 * to sum in the array
 * "renderAs": {
        "type": "FieldSum",
        "class": "html",
        "settings": {
            "namePath": "activeGroups.clientList", (loop over)
            "valuePath": "childRoles.participantCount" (items to count)
        }
    },
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var sum = 0;
    row[settings.namePath].map(function (item) {
      var v = "".concat((0, _get2["default"])(item, settings.valuePath));
      if (!(0, _isNil2["default"])(v) && v !== 'null') {
        sum += +v;
      }
      return sum;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: _style["default"].container
    }, sum > 0 ? /*#__PURE__*/_react["default"].createElement("div", null, sum) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center"
    }));
  };
};